import { render, staticRenderFns } from "./TheMenuCategories.vue?vue&type=template&id=4ffb6e06&"
import script from "./TheMenuCategories.vue?vue&type=script&lang=js&"
export * from "./TheMenuCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TheMenuCategories.vue"
export default component.exports